import { render, staticRenderFns } from "./StyleEditTabPrices.vue?vue&type=template&id=ea0868e4&"
import script from "./StyleEditTabPrices.vue?vue&type=script&lang=js&"
export * from "./StyleEditTabPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports